export const ACTION_STATUS = {
  READY: 'READY',
  LOGINING: 'LOGINING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
};